export default {
  "root": "_root_1mre4_1",
  "animateSparkle": "_animateSparkle_1mre4_6",
  "spin": "_spin_1mre4_1",
  "animateEyes": "_animateEyes_1mre4_10",
  "look-around": "_look-around_1mre4_1",
  "invisible": "_invisible_1mre4_14"
};import "ni:sha-256;xMtVwb1H3q2-z_uV92xqehACzb5m_KOcLUNqv7iP_As";